var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    viewBox: "0 0 44 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.2C0.5 2.14801 2.13142 0.5 4.125 0.5H39.875C41.8686 0.5 43.5 2.14801 43.5 4.2V23.8C43.5 25.852 41.8686 27.5 39.875 27.5H4.125C2.13142 27.5 0.5 25.852 0.5 23.8V4.2Z",
    fill: "#F2EFEE",
    stroke: "#F2EFEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.2C0 1.8804 1.84683 0 4.125 0H39.875C42.1532 0 44 1.8804 44 4.2V23.8C44 26.1196 42.1532 28 39.875 28H4.125C1.84683 28 0 26.1196 0 23.8V4.2Z",
    fill: "#F5DADF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 7,
    height: 3,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 7,
    height: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    width: 7,
    height: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 19,
    width: 7,
    height: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 30.5,
    y: 5,
    width: 9.5,
    height: 7,
    fill: "#E2255E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBlank);
export default __webpack_public_path__ + "static/media/payment-blank.a9bbd96bd594d903231c340fc95cae68.svg";
export { ForwardRef as ReactComponent };